import { apiSlice } from "../../app/api/apiSlice";

export const marketPulseApiSlice = apiSlice.injectEndpoints({
  tagTypes: ["MarketPulse"],           // optional but keeps cache tidy
  endpoints: (builder) => ({
    /* ------------------------------------------------- *
     *  /api/market-pulse/daily?date=YYYY-MM-DD          *
     * ------------------------------------------------- */
    getDailyCounts: builder.query({
      query: (date) => `/market-pulse/daily?date=${date}`,
      providesTags: (res) =>
        res
          ? [
            ...res.map((r) => ({ type: "MarketPulse", id: r.TOPIC_ID })),
            { type: "MarketPulse", id: "LIST" },
          ]
          : [{ type: "MarketPulse", id: "LIST" }],
    }),

    /* ------------------------------------------------- *
     *  /api/market-pulse/topics/:type?range=…&date=…     *
     * ------------------------------------------------- */
    getTopicBreakouts: builder.query({
      query: ({ type, range, date }) =>
        `/market-pulse/topics/${type}?range=${range}&date=${date}`,
      providesTags: (_res, _err, arg) => [
        { type: "MarketPulse", id: `${arg.type}-${arg.range}` },
      ],
    }),

    /* ------------------------------------------------- *
     *  /api/market-pulse/topic/:topicId?date=YYYY-MM-DD *
     * ------------------------------------------------- */
    getTopicSummary: builder.query({
      query: ({ topicId, date }) =>
        `/market-pulse/topic/${topicId}?date=${date}`,
    }),
    getDailyTrend: builder.query({
      query: (params) => {
        const q = new URLSearchParams(params).toString();
        return `/market-pulse/trend?${q}`;
      },
    }),
    /* ------------------------------------------------- *
    * /market-pulse/topic-daily-trend …                 *
    * ------------------------------------------------- */
    getTopicDailyTrend: builder.query({
      query: (params) => `/market-pulse/topic-daily-trend?${new URLSearchParams(params)}`,
    }),
  }),

});

export const {
  useGetDailyCountsQuery,
  useGetTopicBreakoutsQuery,
  useGetTopicSummaryQuery,
  useGetDailyTrendQuery,
  useGetTopicDailyTrendQuery

} = marketPulseApiSlice;
